<template>
    <Card >
        <p slot="title">领用/归还</p>
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="70">
            <FormItem label="姓名" prop="name">
                <Input v-model="formValidate.name" placeholder="Enter your name"/>
            </FormItem>
            <FormItem label="邮箱" prop="mail">
                <Input v-model="formValidate.mail" placeholder="Enter your e-mail"/>
            </FormItem>
            <FormItem label="部门" prop="department">
                <Input v-model="formValidate.department" disabled/>
            </FormItem>
            <FormItem label="是否发送通知邮件" prop="isSendEmail">
                <i-switch v-model="formValidate.isSendEmail" size="large">
                    <span slot="是">是</span>
                    <span slot="否">否</span>
                </i-switch>
            </FormItem>

            <FormItem label="时间" prop="createdAt">
                <DatePicker type="datetime" v-model="formValidate.createdAt" placeholder="Select date and time" disabled style="width: 100%"></DatePicker>
            </FormItem>
            <FormItem label="资产编码" prop="snList" v-for="(_, index) in formValidate.snList" :key="index">
                <Row>
                    <Col span="16"> <Input v-model="formValidate.snList[index]" placeholder="Enter sn..." clearable :disabled="formValidate.snListDisable[index]"/> </Col>
                    <Col span="3" offset="1" v-if="!formValidate.snListDisable[index]"> <Button shape="circle" icon="ios-checkmark" @click="setDisable(index)"/> </Col>
                    <Col span="3" offset="1"> <Button shape="circle" icon="ios-close" @click="remove(index)"/> </Col>
                </Row>
            </FormItem>
            <Row style="margin-bottom: 20px;margin-top:20px">
                <Col span="16" offset="10"> <Button shape="circle" @click="add()">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Button> </Col>
            </Row>
            <FormItem>
                <Col span="12" ><Button @click="handleReset('formValidate')" style="margin-left: 8px">Reset</Button></Col>
                <Button type="primary" @click="handleSubmit('formValidate')">Submit</Button>
            </FormItem>
        </Form>
    </Card>
</template>
<script>
export default {
  data () {
    return {
      formValidate: {
        name: '',
        mail: '',
        department: '',
        isSendEmail: true,
        createdAt: new Date(),
        snList: [''],
        snListDisable: [false]
      },
      ruleValidate: {
        name: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        mail: [
          { required: true, message: 'Mailbox cannot be empty', trigger: 'blur' },
          { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success('Success!')
        } else {
          this.$Message.error('Info Fail!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    remove (index) {
      this.formValidate.snList.splice(index, 1)
      this.formValidate.snListDisable.splice(index, 1)
    },
    setDisable (index) {
      this.formValidate.snListDisable[index] = true
      const snList = this.formValidate.snList
      this.formValidate.snList = []
      snList.forEach(sn => {
        this.formValidate.snList.push(sn)
      })
    },
    add () {
      this.formValidate.snList.push('')
      this.formValidate.snListDisable.push(false)
    }
  }
}
</script>
